import {
  Button,
  Center,
  Divider,
  Heading,
  HStack,
  Input,
  Spacer,
  Tag,
  Text,
  useColorModeValue,
  useToast,
  VStack,
} from "@chakra-ui/react";
import {
  useContractFunction,
  useEtherBalance,
  useEthers,
  useTokenBalance,
} from "@usedapp/core";
import { BigNumber } from "ethers";
import { formatEther, formatUnits, parseUnits } from "ethers/lib/utils";
import React, { useEffect, useState } from "react";
import { useSupportedNetworks } from "../../constants/SupportedNetworks";
import { usePresalePrice,useBNBcollected } from "../../hooks/PresaleHooks";
import { Logo } from "../Logo";
export const SwapUI = () => {
  const { chainId, account } = useEthers();
  const toast = useToast();
  const currentNetwork = useSupportedNetworks[chainId!];
  const userNativeBalanceInWei: BigNumber | undefined =
    useEtherBalance(account);

  const userTokenBalanceInWei: BigNumber | undefined = useTokenBalance(
    currentNetwork?.token?.contractAddress,
    account
  );

  const presalePrice = usePresalePrice();

  const [ethCollected, setEthCollected] = useState<BigNumber | undefined>(undefined);

  useEffect(() => {
    const fetchEthCollected = async () => {
      try {
        const collected = await useBNBcollected();
        setEthCollected(collected);
      } catch (error) {
        console.error("Error fetching BNB collected", error);
      }
    };
    fetchEthCollected();
  }, []);
  const ethCollectedFormatted = ethCollected
    ? parseFloat(formatUnits(ethCollected, 18)).toFixed(8)
    : "0.00000000";
  const [userInput, setUserInput] = useState<{
    ethInput: string;
    tokenInput: string;
  }>({
    ethInput: "",
    tokenInput: "",
  });

  const { send, state, resetState } = useContractFunction(
    currentNetwork?.presaleContractInterface,
    "buy"
  );

  const [transactionStatus, setTransactionStatus] = useState<
    "No" | "Pending Signature" | "Mining"
  >("No");

  const handleEthInput = (e: any) => {
    const value = e.target.value;
    setUserInput((prev) => ({
      ...prev,
      ethInput: value,
      tokenInput:
        value?.length === 0 ? "" : Number(value * presalePrice).toFixed(8),
    }));
  };
  const handleTokenInput = (e: any) => {
    const value = e.target.value;
    setUserInput((prev) => ({
      ...prev,
      ethInput:
        value?.length === 0 ? "" : Number(value / presalePrice).toFixed(8),
      tokenInput: value,
    }));
  };

  const handleSwap = () => {
    if (
      Number(formatEther(userNativeBalanceInWei ?? 0)) <
      Number(userInput?.ethInput)
    ) {
      toast({
        title: "Insufficient Balance.",
        description: "Please enter the amount equal or less then your balance.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } else if (Number(userInput?.ethInput) <= 0.00000000005) {
      toast({
        title: "Please enter valid amount.",
        description: "Please enter value more than 0.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } else {
      proceedSwap();
    }
  };
  const proceedSwap = async () => {
    await send({
      value: parseUnits(userInput?.ethInput),
    });
  };

  useEffect(() => {
    if (state.status === "Exception") {
      toast({
        title: "Error",
        description: state.errorMessage,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      setTransactionStatus("No");
      resetState();
    } else if (state.status === "PendingSignature") {
      setTransactionStatus("Pending Signature");
    } else if (state.status === "Mining") {
      setTransactionStatus("Mining");
    } else if (state.status === "Success") {
      toast({
        title: "Transaction Success",
        description: (
          <VStack w="full">
            <Button
              as="a"
              target="_blank"
              href={currentNetwork?.nativeFunctions?.getExplorerTransactionLink(
                state.receipt?.transactionHash!
              )}
              colorScheme="yellow"
              borderRadius="xl"
            >
              View on {currentNetwork?.explorerLink?.name}
            </Button>
          </VStack>
        ),
        status: "success",
        duration: 50000,
        isClosable: true,
      });

      setTransactionStatus("No");
    }
  }, [state.status]);

  console.log(state);

  return (
    <VStack
      w={{ base: "350px", md: "450px" }}
      className="swap-panel"
      borderRadius="3xl"
      boxShadow="md"
      p={5}
      spacing={5}
    >
      <HStack>
        <Heading size="md">PRESALE - LITTLE BABY PEPE (LBP)</Heading>
      </HStack>
      <Center w="full">
        <Divider />
        
      </Center>
      <p className="bnb-collected">BNB Collected : {ethCollectedFormatted}</p>
      <VStack w="full">
        <HStack w="full">
          <Tag>Balance</Tag>
          <Spacer />
          <Tag colorScheme={"yellow"}>
            {Number(formatEther(userNativeBalanceInWei ?? 0)).toFixed(8)}{" "}
            {currentNetwork?.native?.symbol}
          </Tag>
        </HStack>
        <Input
          placeholder={`Please enter the ${currentNetwork?.native?.symbol} amount to spend`}
          // placeholder={`Please enter the ETH amount to spend`}
          h={16}
          borderRadius="3xl"
          value={userInput?.ethInput}
          onChange={handleEthInput}
        ></Input>
      </VStack>
      <VStack w="full">
        <HStack w="full">
          <Tag>Balance</Tag>
          <Spacer />
          <Tag colorScheme={"pink"}>
            {Number(
              formatUnits(
                userTokenBalanceInWei ?? 0,
                currentNetwork?.token?.decimals
              )
            ).toFixed(8)}{" "}
            {currentNetwork?.token?.symbol}
            
            
          </Tag>
        </HStack>
        <Input
          // placeholder={`Please enter the LBP amount to buy`}
          placeholder={`Please enter the ${currentNetwork?.token?.symbol} amount to buy`}
          h={16}
          borderRadius="3xl"
          value={userInput?.tokenInput}
          onChange={handleTokenInput}
        ></Input>
      </VStack>
      <Button
       className="buy-btn"
        w="full"
        h={20}
        borderRadius="3xl"
        onClick={handleSwap}
        isDisabled={userInput?.ethInput.length === 0}
        isLoading={
          transactionStatus === "Mining" ||
          transactionStatus === "Pending Signature"
        }
        loadingText={`Processing`}
      >
        BUY
      </Button>
    </VStack>
  );
};
